import React, { useState, useEffect } from "react";
// import SearchBar from "./searchbar";

const Footer: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="w-full flex justify-center border-b-[1px]">
        <div className="w-full max-w-[1116px] h-[90px] px-8 flex items-center justify-between">
          <div
            className={` ${
              windowWidth > 800 ? "text-3xl" : "text-2xl"
            } font-bold hover:text-[#5b68d3] cursor-pointer`}
            onClick={() => (window.location.href = "/")}
          >
            JuicyQuestleisure06
          </div>

          {/* <SearchBar /> */}

          <button
            // type="text"
            // onClick={windowWidth > 800 ? showLargeDrawer : showDefaultDrawer}
            onClick={() => (window.location.href = "/search")}
            className="flex items-center"
          >
            <img
              src="icon/search.png"
              alt="searchBtn"
              className={`mx-1 ${windowWidth > 800 ? "w-5 h-5" : "w-5 h-5"}`}
            />
            <span
              className={`font-semibold text-[#5c687a] ${
                windowWidth > 800 ? "text-base" : "text-base"
              }`}
            >
              Search
            </span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Footer;
